import React from 'react';

function CustomerNameFieldRendicontazioni({ data }) {
  if (data.customerInfo && data.customerInfo.type === 'AZIENDA') {
    return <>{data.customerInfo.businessName}</>;
  } else if (data.customerInfo && data.customerInfo.type === 'PRIVATO') {
    return (
      <>
        {data.customerInfo.name} {data.customerInfo.surname}
      </>
    );
  } else if (data.customerInfo) {
    return <>{data.customerInfo.name}</>;
  } else {
    return <>-</>;
  }
}

export default CustomerNameFieldRendicontazioni;
